/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_4Inputs */

const en_claims_step_4 = /** @type {(inputs: Claims_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in the details below and attach the claim form and any relevant medical records or bills.`)
};

const fr_claims_step_4 = /** @type {(inputs: Claims_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplissez les informations ci-dessous et joignez le formulaire de réclamation ainsi que tout dossier médical ou facture pertinents.`)
};

/**
* | output |
* | --- |
* | "Fill in the details below and attach the claim form and any relevant medical records or bills." |
*
* @param {Claims_Step_4Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_4 = /** @type {((inputs?: Claims_Step_4Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_4Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_4(inputs)
	return fr_claims_step_4(inputs)
});